// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__Yhlap","requiredAsterisk":"Info_requiredAsterisk__16JU7"};